import moment from "moment";
import { DateUtils } from "~app/common/utils/date-utils";
import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";

export class HandelssortimentSearchResultViewModel {
    constructor(private readonly model: ISearchHandelssortimentModel) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get beteckning() {
        return this.model.beteckning;
    }

    get sortiment() {
        return this.model.sortiment != null ? this.maxLength(this.model.sortiment.map(s => s.kod).join(", ")) : "";
    }

    get tooltipSortiment() {
        return this.model.sortiment != null ? this.model.sortiment.map(s => s.namn).join(",") : "";
    }

    get handelssortimentsgrupp() {
        return this.model.handelssortimentsgrupp.namn;
    }

    get produkter() {
        return this.model.produkter != null ? this.maxLength(this.model.produkter.map(p => p.namn).join(", ")) : "";
    }

    get tooltipProdukter() {
        return this.model.produkter != null ? this.model.produkter.map(p => p.beteckning).join(", ") : "";
    }

    get giltighetFrom() {
        if (!this.model.giltighetFrom) {
            return "";
        }

        return moment(this.model.giltighetFrom).format(DateUtils.dateformat);
    }

    get giltighetTom() {
        if (!this.model.giltighetTom) {
            return "";
        }

        return moment(this.model.giltighetTom).format(DateUtils.dateformat);
    }

    get aktiv() {
        return this.model.aktiv;
    }

    get forProduktion() {
        return this.model.forProduktion;
    }

    get forInmatning() {
        return this.model.forInmatning;
    }

    get violid() {
        return this.model.violId;
    }

    maxLength(s: string) {
        // eslint-disable-next-line sonarjs/deprecation
        return s && s.length > 40 ? `${s.substr(0, 38)}..` : s;
    }
}
